import {
  CardsByChannelData,
  CompletionRate,
  LearnsSummary,
  LearnsSummaryDetails,
  RespTimeSchedules,
  RespTimes,
  ScheduleSummary,
  ScheduleSummaryResources,
  TopCohortResponseDetails,
  TopCohortsByResp,
  TopCourseByLearners,
  TopCourseDetails,
  TopCourseResponseDetails,
  TopCoursesByResp,
} from "@mikros/library";
import React, { useEffect, useState } from "react";
import ApiServices from "../../service/apiService";
import {
  DropDownList,
  DropDownListChangeEvent,
} from "@progress/kendo-react-dropdowns";
import {
  Chart,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartSeries,
  ChartSeriesItem,
  SeriesLine,
} from "@progress/kendo-react-charts";
import { DateRangePicker } from "@progress/kendo-react-dateinputs";
import { FormattedMessage, useIntl } from "react-intl";
import CustomProgress from "./progressbar";
import Account from "../../utils/apiConfig";
import ErrorHandler from "../../utils/errorConfig";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Alert } from "@mikros/shared-ui";
import { useNavigate } from "react-router-dom";

export interface SummaryDisplayProps {
  // fetchSummarySchedules: () => void;
}

export function SummaryDisplay(props: SummaryDisplayProps) {
  const intl = useIntl();
  const allData = [
    intl.formatMessage({ id: "analytics.summaryDisplay.today" }),
    intl.formatMessage({ id: "analytics.summaryDisplay.yesterday" }),
    intl.formatMessage({ id: "analytics.summaryDisplay.last7Days" }),
    intl.formatMessage({ id: "analytics.summaryDisplay.lastWeek" }),
    intl.formatMessage({ id: "analytics.summaryDisplay.last30Days" }),
    intl.formatMessage({ id: "analytics.scheduleDisplay.inProgress" }),
    intl.formatMessage({ id: "analytics.summaryDisplay.lastMonth" }),
    intl.formatMessage({ id: "analytics.summaryDisplay.weekToDate" }),
    intl.formatMessage({ id: "analytics.summaryDisplay.monthToDate" }),
    intl.formatMessage({ id: "analytics.summaryDisplay.quarterToDate" }),
    intl.formatMessage({ id: "analytics.summaryDisplay.yearToDate" }),
    intl.formatMessage({ id: "analytics.summaryDisplay.customRange" }),
  ];

  const [customRange, setCustomRange] = useState<boolean>(false);
  const [selectedValue, setSelectedValue] = useState();
  const currentDate = new Date();

  const navigate = useNavigate();
  const accountInstance = Account.getInstance();
  const errorInstance = ErrorHandler.getErrorInstance();

  const timeRanges = {
    yesterday: "YDAY",
    today: "TDAY",
    lastMonth: "LMONTH",
    lastThirtyDays: "L30DAYS",
    lastWeek: "LWEEK",
    lastSevenDays: "L7DAYS",
    yearToDate: "YTODATE",
    quarterToDate: "QTODATE",
    monthToDate: "MTODATE",
    weekToDate: "WTODATE",
    customToDate: "CUSTOM",
  };

  const today = new Date();
  today.setUTCHours(0, 0, 0, 0);
  const [dropFromTimeQuery, setDropFromTimeQuery] = useState<number>(
    today.getTime()
  );
  const [dropTillTimeQuery, setDropTillTimeQuery] = useState<number>(
    today.getTime()
  );
  const [timeRange, setTimeRange] = useState<string>("TDAY");

  console.log("constant received from time outside", timeRange);

  const [summarySchedules, setSummarySchedules] = useState<ScheduleSummary>({
    resources: [{} as ScheduleSummaryResources],
  } as ScheduleSummary);

  const [compRate, setCompRate] = useState<CompletionRate>(
    {} as CompletionRate
  );
  const [courseLearners, setCourseLearners] = useState<TopCourseByLearners>({
    resources: [{} as TopCourseDetails],
  } as TopCourseByLearners);
  const [courseByResp, setCourseByResp] = useState<TopCoursesByResp>({
    resources: [{} as TopCourseResponseDetails],
  } as TopCoursesByResp);
  const [cohortByResp, setCohortByResp] = useState<TopCohortsByResp>({
    resources: [{} as TopCohortResponseDetails],
  } as TopCohortsByResp);
  const [fastRespSched, setFastRespSched] = useState<RespTimes>({
    resources: [{} as RespTimeSchedules],
  } as RespTimes);
  const [cardsByChannel, setCardsByChannel] = useState<CardsByChannelData>(
    {} as CardsByChannelData
  );

  const [learn, setLearn] = useState<LearnsSummary>({
    resources: [{} as LearnsSummaryDetails],
  } as LearnsSummary);

  console.log(
    "learn categories",
    learn?.resources.map((cat) => {
      cat.cardsSent;
    })
  );
  const [cat, setCategories] = useState([]);

  const [errorFlag, setErrorFlag] = useState<boolean>(false);

  console.log("Print categories", cat);
  console.log("learn resources", learn?.resources);
  const cardString = JSON.stringify(cardsByChannel);
  console.log("sum res name", summarySchedules);

  const channelDataArray =
    cardsByChannel && typeof cardsByChannel === "object" && !Array.isArray(cardsByChannel)
      ? Object.entries(cardsByChannel)
          .filter(([channel]) => channel !== "totalCards")
          .map(([channel, count]) => ({ channel: String(channel), count: Number(count as any) || 0 }))
      : [];

  channelDataArray?.sort((a: any, b: any) => b.count - a.count);
  const topThreeChannel = channelDataArray?.slice(0, 3);

  console.log("top three channel", topThreeChannel);
  console.log("learners summary", learn?.resources);

  const [selectedRange, setSelectedRange] = React.useState<any>();

  const learnCategories = Array.isArray(learn?.resources)
    ? learn.resources.map((item: any) => item?.category)
    : [];

  const learnCardsSent = Array.isArray(learn?.resources)
    ? learn.resources.map((item: any) => item?.cardsSent ?? 0)
    : [];
  const learnCardsAck = Array.isArray(learn?.resources)
    ? learn.resources.map((item: any) => item?.cardsAck ?? 0)
    : [];

  function getCustomSummarySchedules() {
    const startDate = new Date(selectedRange?.start).getTime();
    const endDate = new Date(selectedRange?.end).getTime();

    console.log(
      "please print the custom from time inside custom function here for youuuuuuuuuuu",
      startDate
    );
    console.log(
      "please print custom till time insid custom function youuuuuuuuuuuuuu",
      endDate
    );
    let api = ApiServices.getInstance();

    if (startDate && endDate && accountInstance.accntId) {
      api
        .makeRequest(
          `${accountInstance.accntId}/analytics/summary?fromtime=${startDate}&tilltime=${endDate}&option=CUSTOM`,
          "GET"
        )
        .then(async (data) => {
          if (data && data.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          }
          // setSummarySchedules(data)
          console.log("data", data);
          console.log("learners insight summary display custom", data);
          setSummarySchedules(data?.scheduleSummary);
          setCompRate(data?.dataRates?.completionRate);
          setCourseLearners(data?.dataRates?.topCourseByLearners);
          setCourseByResp(data?.dataRates?.topCoursesByResp);
          setCohortByResp(data?.dataRates?.topCohortsByResp);
          setFastRespSched(data?.dataRates?.respTimes);
          setCardsByChannel(data?.dataRates?.cardsByChannelData);
          setLearn(data?.learnsSummary);
          const extractedCategories = data?.learnsSummary.map(
            (item: { category: any }) => item.category
          );
          setCategories(extractedCategories);
        });
    }
  }

  function getConstSummarySchedules() {
    let api = ApiServices.getInstance();
    if (
      selectedValue !==
        // "Custom Range"
        intl.formatMessage({ id: "analytics.summaryDisplay.customRange" }) &&
      timeRange !== "CUSTOM" &&
      timeRange &&
      accountInstance.accntId
    ) {
      const basePath = `${accountInstance.accntId}/analytics/summary?&option=${timeRange}`;
      const dataRatesPath = `${accountInstance.accntId}/analytics/summary?&option=${timeRange}&choice=dataRates`;

      Promise.allSettled([
        api.makeRequest(basePath, "GET"),
        api.makeRequest(dataRatesPath, "GET"),
      ]).then(async ([baseResult, dataRatesResult]) => {
        // Handle base response (summary + learns)
        if (baseResult.status === "fulfilled") {
          const data: any = baseResult.value;
          if (data && data.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
          } else {
            console.log("base summary data", data);
            setSummarySchedules(data?.scheduleSummary);
            setLearn(data?.learnsSummary);
          }
        } else {
          console.error("Base summary request failed", baseResult.reason);
        }

        // Handle dataRates response (metrics)
        if (dataRatesResult.status === "fulfilled") {
          const rates: any = dataRatesResult.value;
          if (rates && rates.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(rates.errorMessage);
          } else {
            console.log("data rates", rates);
            setCompRate(rates?.dataRates?.completionRate);
            setCourseLearners(rates?.dataRates?.topCourseByLearners);
            setCourseByResp(rates?.dataRates?.topCoursesByResp);
            setCohortByResp(rates?.dataRates?.topCohortsByResp);
            setFastRespSched(rates?.dataRates?.respTimes);
            setCardsByChannel(rates?.dataRates?.cardsByChannelData);
          }
        } else {
          console.error("Data rates request failed", dataRatesResult.reason);
        }
      });
    }
  }

  useEffect(() => {
    getConstSummarySchedules();
  }, [timeRange]);

  useEffect(() => {
    let timeConst = "";
    if (
      selectedValue ===
      intl.formatMessage({ id: "analytics.summaryDisplay.yearToDate" })
    ) {
      timeConst = timeRanges["yearToDate"];
      setCustomRange(false);
    } else if (
      selectedValue ===
      intl.formatMessage({ id: "analytics.summaryDisplay.lastWeek" })
    ) {
      timeConst = timeRanges["lastWeek"];
      setCustomRange(false);
    } else if (
      selectedValue ===
      intl.formatMessage({ id: "analytics.summaryDisplay.last7Days" })
    ) {
      timeConst = timeRanges["lastSevenDays"];
      setCustomRange(false);
    } else if (
      selectedValue ===
      intl.formatMessage({ id: "analytics.summaryDisplay.last30Days" })
    ) {
      timeConst = timeRanges["lastThirtyDays"];
      setCustomRange(false);
    } else if (
      selectedValue ===
      intl.formatMessage({ id: "analytics.summaryDisplay.lastMonth" })
    ) {
      timeConst = timeRanges["lastMonth"];
      setCustomRange(false);
    } else if (
      selectedValue ===
      intl.formatMessage({ id: "analytics.summaryDisplay.weekToDate" })
    ) {
      timeConst = timeRanges["weekToDate"];
      setCustomRange(false);
    } else if (
      selectedValue ===
      intl.formatMessage({ id: "analytics.summaryDisplay.monthToDate" })
    ) {
      timeConst = timeRanges["monthToDate"];
      setCustomRange(false);
    } else if (
      selectedValue ===
      intl.formatMessage({ id: "analytics.summaryDisplay.quarterToDate" })
    ) {
      timeConst = timeRanges["quarterToDate"];
      setCustomRange(false);
    } else if (
      selectedValue ===
      intl.formatMessage({ id: "analytics.summaryDisplay.yesterday" })
    ) {
      timeConst = timeRanges["yesterday"];
      setCustomRange(false);
    } else if (
      selectedValue ===
      intl.formatMessage({ id: "analytics.summaryDisplay.today" })
    ) {
      timeConst = timeRanges["today"];
      setCustomRange(false);
    } else if (
      selectedValue ===
      intl.formatMessage({ id: "analytics.summaryDisplay.customRange" })
    ) {
      setCustomRange(true);
      getCustomSummarySchedules();
    }
    setTimeRange(timeConst);
  }, [selectedValue, selectedRange]);

  console.log("sum res name", summarySchedules);
  console.log("comp rate count", compRate?.cardsAcknowledgedCount);
  console.log("course learners", courseLearners);
  console.log("course by response", courseByResp);
  console.log("fast resp schedules", fastRespSched);
  console.log("cards by channel data", cardsByChannel);
  console.log("jsonify cards by channel data", JSON.stringify(cardsByChannel));
  console.log("card string", cardString);
  console.log("learners summary", learn);

  const firstSeries = [123, 276, 310, 212, 240, 156, 98];
  const secondSeries = [100, 209, 300, 200, 220, 150, 90];
  const [lineStyle, setLineStyle] =
    React.useState<SeriesLine["style"]>("smooth");
  let categories = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  const category2 = ["Mon", "Tue", "Wed", "Thur", "Fri", "Sat", "Sun"];
  const barSeries = [];
  const [summaryDisplay, setSummaryDisplay] = useState<string>();

  const handleDropDownChange = (event: DropDownListChangeEvent) => {
    setSelectedValue(event.value);
  };
  const [customstartDate, setCustomStartDate] = useState(new Date());

  let selectedRangeString = JSON.stringify(selectedRange);
  console.log("selected range string jsonified", selectedRangeString);

  const handleRangeChange = (event: any) => {
    setSelectedRange(event.value);
    setDropFromTimeQuery(event.value.start);
    setDropTillTimeQuery(event.value.end);
  };

  let category: any[];
  let cardsSent: any[];
  let cardsAck: any[];

  summarySchedules?.resources?.map((item, index) => item.ackCardCnt);
  console.log();

  useEffect(() => {
    async function initializeAndUseAccount() {
      await accountInstance.fetchAccountId();
      console.log(
        "account id instance in tenant side",
        accountInstance.accntId
      );
    }
    initializeAndUseAccount();
  }, []);

  return (
    <div>
      {errorFlag && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: errorInstance.errorCode,
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              setErrorFlag(false);
              if (errorInstance.permDenied === true) {
                navigate("/home");
              } else {
                navigate("/reports");
              }
            }}
          />
        </Dialog>
      )}
      <div className="w-full flex justify-start items-center mt-[-2.25rem]">
        <DropDownList
          data={allData}
          defaultValue={intl.formatMessage({
            id: "analytics.summaryDisplay.today",
          })}
          onChange={handleDropDownChange}
          className="w-48 text-sm mr-4 bg-mk-primary-50"
        />
      </div>

      <div className="w-1/4 mt-2">
        {customRange && (
          <div className="food-demo card-container">
            <div className="k-card custom-card">
              <div className="card-row">
                <div className="card-column">
                  <div className="component-container">
                    <form
                      className="k-form"
                      onSubmit={(e) => e.preventDefault()}
                    >
                      <fieldset>
                        <DateRangePicker
                          value={selectedRange}
                          onChange={handleRangeChange}
                          max={currentDate}
                        />
                      </fieldset>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="bg-mk-white rounded-lg shadow-md mt-6 h-64 overflow-y-auto ">
        <div className="text-mk-primary-bright text-xl font-semibold pl-3 pt-2">
          <FormattedMessage id="schedules.title" />
        </div>
        {/* <div className="text-mk-text-grey flex justify-around mt-3"> */}
        <div className="text-mk-text-grey flex mt-3">
          <div className="w-[30%] text-center">
            <FormattedMessage id="analytics.summaryDisplay.scheduleName" />
          </div>
          <div className="w-[30%] text-center">
            <FormattedMessage id="analytics.summaryDisplay.courseName" />
          </div>

          <div className="flex flex-col items-center justify-center w-[40%]">
            <div className="text-center">
              <FormattedMessage id="analytics.summaryDisplay.cards" />
              <div className="border-b border-mk-grey w-96"></div>
            </div>
            <div className="flex flex-row justify-between items-center mt-2 ">
              <div className="mr-16">
                <FormattedMessage id="analytics.summaryDisplay.acknowledged" />
              </div>
              <div className="ml-16 mb-4">
                <FormattedMessage id="analytics.summaryDisplay.notAcknowledged" />
              </div>
            </div>
          </div>
        </div>

        {summarySchedules?.resources?.map((item, index) => (
          <div
            key={index}
            // className="flex items-center justify-start pl-8 pr-8 "
            className={`flex items-center justify-start pl-8 pr-8 ${
              index % 2 === 0
            } `}
          >
            <div
              className={`text-mk-very-dark-grey h-10 w-full cursor-pointer text-lg ${
                index % 2 === 0
                  ? "rounded-xl bg-mk-primary-50"
                  : "rounded-none bg-mk-white"
              }
`}
            >
              <div className="flex h-full font-semibold text-sm justify-start items-center">
                <div className="flex justify-start items-center ml-6 w-1/3">
                  {item.scheduleName}
                </div>

                <div className="flex justify-start items-center w-1/3">
                  {item.courseName}
                </div>

                <div className="flex items-center w-1/3">
                  <div className="w-auto pr-1">0</div>

                  <div className="w-5/6">
                    <CustomProgress
                      progress={item.ackCardCnt}
                      progressColor="bg-mk-mild-green"
                      completeColor="#FF8274"
                      totalWidth={100}
                      totalCardCount={item.totalCards}
                      textColor="#6464E5"
                    />
                  </div>
                  <div className="w-auto pl-1">{item.totalCards}</div>
                </div>
              </div>
            </div>
          </div>
        ))}
        <div className="pb-[5%]"></div>
      </div>

      <div className="grid grid-cols-3 gap-8 mt-4">
        <div className="bg-mk-white shadow-md rounded-lg h-48">
          <div className="text-mk-primary-bright p-4 font-medium">
            <div className="flex justify-items-end items-start h-1/5 text-mk-primary-bright text-xl font-semibold">
              <FormattedMessage id="analytics.summaryDisplay.completionRate"></FormattedMessage>
            </div>

            <div className="flex justify-start items-center h-1/5 text-mk-primary-bright w-1/30">
              <div className="flex w-1/6 font-extrabold text-2xl ">
                {/* 800 */}
                {compRate?.cardsSentCount}
              </div>
            </div>

            <div>
              <div className="flex justify-around items-end h-1/5 text-mk-primary-bright mt-3">
                <div className="w-2/3">
                  {/* Cards sent */}
                  <FormattedMessage id="analytics.summaryDisplay.cardsSent"></FormattedMessage>
                </div>

                <div className="w-1/6">
                  <div className="text-right">{compRate?.cardsSentCount}</div>
                </div>

                <div className="w-1/6 flex items-center justify-end"></div>
              </div>

              <div className="flex justify-around items-end h-1/5 text-mk-primary-bright mt-3">
                <div className="w-2/3">
                  {/* Cards delivered */}
                  <FormattedMessage id="analytics.summaryDisplay.cardsDelivered"></FormattedMessage>
                </div>

                <div className="w-1/6">
                  <div className="text-right">
                    {compRate?.cardsDeliveredCount}
                  </div>
                </div>

                <div className="w-1/6"></div>
              </div>

              <div className="flex justify-around items-end h-1/5 text-mk-primary-bright mt-3">
                <div className="w-2/3">
                  {/* Cards acknowledged */}
                  <FormattedMessage id="analytics.summaryDisplay.cardsAcknowledged"></FormattedMessage>
                </div>

                <div className="w-1/6">
                  <div className="text-right">
                    {compRate?.cardsAcknowledgedCount}
                  </div>
                </div>

                <div className="w-1/6"></div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-mk-white shadow-md rounded-lg h-48">
          <div className="text-mk-primary-bright p-4 font-medium">
            <div className="flex justify-items-end items-start h-1/5 text-mk-primary-bright text-xl font-semibold">
              {/* Top Course By Learners */}
              <FormattedMessage id="analytics.summaryDisplay.topCourseLearner"></FormattedMessage>
            </div>
            <div className="flex justify-start items-center h-1/5 text-mk-primary-bright w-1/36">
              <div className="flex w-1/6 font-extrabold text-2xl ">
                {courseLearners?.totalLearnerCnt}
              </div>
            </div>
            {courseLearners?.resources?.map((item) => (
              <div>
                <div className="flex justify-around items-end h-1/5 text-mk-primary-bright mt-3">
                  <div className="w-3/4">{item.courseName}</div>

                  <div className="w-1/4">
                    <div className="text-center">{item.learnersCount}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-mk-white shadow-md rounded-lg h-48">
          <div className="text-mk-primary-bright p-4 font-medium">
            <div className="flex justify-items-end items-start h-1/5 text-mk-primary-bright text-xl font-semibold">
              {/* Top Course By Response */}
              <FormattedMessage id="analytics.summaryDisplay.topCourseResponse"></FormattedMessage>
            </div>

            {courseByResp?.resources?.map((item) => (
              <div>
                <div className="mb-[5%]"></div>

                <div className="flex justify-around items-end h-1/4 text-mk-primary-bright">
                  <div className="w-3/4">{item.courseName}</div>

                  <div className="w-1/4">
                    <div className="text-center">{item.responsePercent}%</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-8 mt-3">
        <div className="bg-mk-white shadow-md rounded-lg h-48">
          <div className="text-mk-primary-bright p-4 font-medium">
            <div className="flex justify-items-end items-start h-1/5 text-mk-primary-bright text-xl font-semibold">
              {/* Top Cohort  By Response */}
              <FormattedMessage id="analytics.summaryDisplay.topCohortResponse"></FormattedMessage>
            </div>
            {cohortByResp?.resources?.map((item) => (
              <div>
                <div className="mb-[5%]"></div>

                <div className="flex justify-around items-end h-1/4 text-mk-primary-bright">
                  <div className="w-3/4">{item.cohortName}</div>

                  <div className="w-1/4">
                    <div className="text-center">
                      {/* 10% */}
                      {item.responsePercent}%
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-mk-white shadow-md rounded-lg h-48 overflow-y-auto">
          <div className="text-mk-primary-bright p-4 font-medium">
            <div className="flex justify-items-end items-start h-1/5 text-mk-primary-bright text-xl font-semibold">
              {/* Fastest Responsing Schedule  */}
              <FormattedMessage id="analytics.summaryDisplay.fastRespSched"></FormattedMessage>
            </div>

            <div className="flex justify-start items-center h-1/5 text-mk-primary-bright w-1/36">
              <div className="flex w-1/6 font-extrabold text-2xl ">
                {fastRespSched?.avgRespTime}
              </div>
              {/* <div className="w-1/6">/12%</div> */}
            </div>
            {fastRespSched?.resources?.map((item) => (
              <div className="overflow-y-auto">
                <div className="flex justify-around items-end h-1/5 text-mk-primary-bright mt-2 text-sm">
                  <div className="w-3/4">
                    {/* {item.scheduleName && typeof item.scheduleName === 'string' && item.scheduleName.length> maxLength?`${item.scheduleName.slice(0,maxLength)}...`: */}
                    {item.scheduleName}
                  </div>

                  <div className="w-1/4">
                    <div className="text-center">
                      {/* 10 min */}
                      {item.respTime} min
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-mk-white shadow-md rounded-lg h-48 border:20px">
          <div className="text-mk-primary-bright p-4 font-medium">
            <div className="flex justify-items-end items-start h-1/5 text-mk-primary-bright text-xl font-semibold">
              <FormattedMessage id="analytics.summaryDisplay.cardsByChannel"></FormattedMessage>
            </div>

            <div className="flex justify-start items-center h-1/5 text-mk-primary-bright w-1/36">
              <div className="flex w-1/6 font-extrabold text-2xl ">
                {typeof cardsByChannel?.totalCards === "number" ? cardsByChannel.totalCards : 0}
              </div>
            </div>
            {topThreeChannel?.map((item) => (
              <div>
                <div className="flex justify-around items-end h-1/5 text-mk-primary-bright mt-3">
                  <div className="w-3/4">{String(item.channel)}</div>

                  <div className="w-1/4">
                    <div className="text-center">{Number(item.count) || 0}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="bg-mk-white rounded-lg shadow-md mt-6 h-full overflow-y-auto flex flex-col">
        <div className="text-mk-primary-bright text-xl font-semibold pl-4 pt-2 text-left">
          <FormattedMessage id="analytics.learnerInsight" />
        </div>

        <div className="w-full p-8 h-fit ">
          <Chart>
            <ChartCategoryAxis>
              <ChartCategoryAxisItem categories={learnCategories} />
            </ChartCategoryAxis>
            <ChartSeries>
              <ChartSeriesItem
                type="area"
                data={learnCardsSent}
                color="#FF8274"
                line={{ style: lineStyle }}
                opacity={0.3}
              />
              <ChartSeriesItem
                type="bar"
                gap={10}
                width={0.5}
                color="#9AA4EC"
                data={learnCardsAck}
              />
            </ChartSeries>
          </Chart>
        </div>
      </div>
    </div>
  );
}
